import * as React from 'react';
import SiteBuilderModel from '../../model/SiteBuilderModel';
import Logger from '../../../../services/Logger';
import { observer } from 'mobx-react-lite';
import useBodyClassToggle from '../../../../hooks/useBodyClassToggle';

interface FCProps {
  width: string;
}

const Preview: React.ForwardRefExoticComponent<
  FCProps & React.RefAttributes<HTMLIFrameElement>
> = observer(
  React.forwardRef((props, ref) => {
    // When the preview iframe is visible we want to prevent the page from scrolling.
    useBodyClassToggle('preview-no-scroll', SiteBuilderModel.iframeVisibility);
    return (
      <iframe
        frameBorder={0}
        className="preview-iframe w-full mx-auto"
        ref={ref}
        id={'wizard-iframe'}
        key={SiteBuilderModel.iframeUrl}
        style={
          SiteBuilderModel.iframeLoaded
            ? { width: props.width }
            : { display: 'none' }
        }
        src={SiteBuilderModel.iframeUrl}
        onLoad={() => {
          Logger.log('iframe loaded');
          SiteBuilderModel.setIframeLoaded(true);
        }}
      />
    );
  })
);

export default Preview;
